const filterModule = {
    namespaced: true,
    persistent: true,
    state: {
        textualFilter: {},
        brandFilter: {},
        inStockFilter: {},
        viewMode: {}
    },
    mutations: {
        setTextualFilter(state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            state.textualFilter[userId] = {};
            state.textualFilter[userId][warehouseId] = payload.textualFilter;
        },
        setBrandFilter(state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            state.brandFilter[userId] = {};
            state.brandFilter[userId][warehouseId] = payload.brandFilter;
        },
        setInStockFilter(state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            state.inStockFilter[userId] = {};
            state.inStockFilter[userId][warehouseId] = payload.inStockFilter;
        },
        setViewMode(state, payload) {
            let userId = payload.userId;
            let warehouseId = payload.warehouseId;
            state.viewMode[userId] = {};
            state.viewMode[userId][warehouseId] = payload.viewMode;
        },
        reset(state) {
            state.textualFilter = {};
            state.brandFilter = {};
            state.inStockFilter = {};
            state.viewMode = {};
        }
    },
    getters: {
        getTextualFilter: state => (userId, warehouseId) => {
            return ((state.textualFilter[userId] || {})[warehouseId] || null);
        },
        getBrandFilter: state => (userId, warehouseId) => {
            return ((state.brandFilter[userId] || {})[warehouseId] || null);
        },
        getInStockFilter: state => (userId, warehouseId) => {
            return ((state.inStockFilter[userId] || {})[warehouseId] ?? 1);
        },
        getViewMode: state => (userId, warehouseId) => {
            return ((state.viewMode[userId] || {})[warehouseId] || 'card');
        }
    }
};

export default filterModule;
